import type { ObjectId } from "@bbj-types/utils";
import { useCallback } from "react";
import { workshopsAxios } from "./axios";

export const useGenerateIcalWorkshopsEvents = () => {
  const [state, execute, cancel] = workshopsAxios<void, void, unknown>(
    {
      method: "GET",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (ids: ObjectId[]) => {
      return execute({
        url: "/sendEvent",
        params: { ids },
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
